<template>
  <div :class="sectionClasses">
    <Button
      v-for="(button, index) in buttonRow"
      :key="index"
      v-bind="{ buttonProps: button }"
      :class="{
        'flex-grow md:flex-grow-0': true,
        'w-full max-w-64': verticalStack,
      }"
    ></Button>
  </div>
</template>
<script lang="ts" setup>
import Button from '../Button/Button.vue';
import type { ButtonRow } from '~/sanity/types';
const props = defineProps<ButtonRow>();
const { alignment, verticalStack } = toRefs(props);
const alignmentClass = computed(
  () => alignmentClasses[alignment.value ?? 'center'] ?? alignmentClasses['center']
);
const sectionClasses = computed(() => [
  'container px-0 button-wrapper flex gap-3 items-center flex-wrap',
  verticalStack.value ? 'flex-col' : '',
  alignmentClass.value,
]);
const alignmentClasses: Record<string, string> = {
  left: 'text-left justify-start',
  center: 'text-center justify-center',
  right: 'text-right justify-end',
};
</script>

<style scoped></style>
